import { type Theme } from '@carbonify/ui';
import gql, { Image, ImageFragment, MetaTags, MetaTagsFragment } from 'services/graphql';
import { Filter, Locale } from 'services/graphql/types';

interface NavigationColumn {
  category: string;
  categoryLink?: string;
  item: string;
  _editingUrl: string;
}

export interface BrandConfigResult {
  id: string;
  tenant: string;
  brandName: string;
  theme?: Theme;
  locale: Locale;
  primaryDomain: string;
  settings: {
    logo?: Image;
    address?: string;
    favicon?: { url: string };
    _editingUrl?: string;
    socialLinks?: Record<string, string>;
  } & MetaTags;
  announcement?: AnnouncementBarRecord;
  header?: {
    logo?: Image;
    lightLogo?: Image;
    mainLinks?: string;
    authenticatedCta?: string;
    navigationSections?: NavigationColumn[];
    logoutLabel: string;
    signupLabel: string;
    loginLabel: string;
    contactLabel: string;
    _editingUrl?: string;
  };
  footer?: {
    logo?: Image;
    footerColumns?: NavigationColumn[];
    _editingUrl?: string;
  };
}

export interface AnnouncementBarRecord {
  id: string;
  message: string;
  name: string;
  cta: string;
  _editingUrl?: string;
}

interface BrandModelFilter {
  id?: Filter<string>;
  tenant?: Filter<string>;
}

export default gql<{ brand: BrandConfigResult }, { filter: BrandModelFilter; locale: Locale }>`
  query query($filter: BrandModelFilter, $locale: SiteLocale) {
    brand(filter: $filter, locale: $locale) {
      id
      tenant
      brandName
      theme
      primaryDomain
      settings {
        address
        socialLinks
        logo {
          ...Image
        }
        ...MetaTags
        favicon {
          url
        }
        _editingUrl
      }
      announcement {
        id
        message
        name
        cta
        _editingUrl
      }
      header {
        logo {
          ...Image
        }
        lightLogo {
          ...Image
        }
        mainLinks
        authenticatedCta
        _editingUrl
        navigationSections {
          category
          categoryLink
          item
          _editingUrl
        }
        loginLabel
        logoutLabel
        signupLabel
        contactLabel
      }
      footer {
        logo {
          ...Image
        }
        footerColumns {
          category
          categoryLink
          item
          _editingUrl
        }
      }
    }
  }
  ${ImageFragment}
  ${MetaTagsFragment}
`;
